import type { AppState, Recipe } from '../types';
import { DEFAULT_SETTINGS } from '../types';
import seed from '../../seed.json';

type SeedFile = { schema_version: 1; recipes: Recipe[] };

export function loadSeedRecipes(): Recipe[] {
  const file = seed as unknown as SeedFile;
  return file.recipes.map(r => ({ ...r, is_seed: true }));
}

export function buildInitialState(familySlug: string, nowIso: string): AppState {
  return {
    schema_version: 1,
    family_slug: familySlug,
    updated_at: nowIso,
    recipes: loadSeedRecipes(),
    weeks: [],
    settings: { ...DEFAULT_SETTINGS },
  };
}
